import web from './web'
import app from './app'
import pda from './pda'
import wap from './wap'

export default [...web, ...app, ...pda, ...wap]